import React, { useContext, useState, useEffect } from "react";
import SidePanel from "../side-panel";
import * as styles from "./style.mod.scss";
import locale from "locales";
import GlobalContext from "services/global-context";

const Activation = ({ wasOpened, data }) => {
  const [opened, setOpened] = useState(false);
  const [closing, setClosing] = useState(false);
  const { setCurrentPanel } = useContext(GlobalContext);
  const loc = locale.register;

  const handleLogin = () => {
    setCurrentPanel("login");
    return false;
  };

  useEffect(() => {
    setTimeout(() => !closing && setOpened(true), 0);
  });

  const handleClose = () => {
    setClosing(true);
    setOpened(false);
    setTimeout(() => setCurrentPanel(null), 250);
  };

  const isOpen = () => opened || (!closing && wasOpened);

  return <SidePanel
    open={true}
    bodyClass={styles.body}
    className={`${styles.sidePanel} ${isOpen() ? styles.opened : ""}`}
    onClose={handleClose}
  >
    <h3>Danke für deine Anmeldung</h3>
    <div className="row">
      <p className={styles.message}>{data?.currentPanel?.message}</p>
      <div className="col-12">
        <p className={styles.links}>
          {loc.haveAccount} <a href="#" onClick={handleLogin}>{loc.login}</a>
        </p>
      </div>
    </div>
  </SidePanel>;
};

export default Activation;
